import { FolderIcon } from '@heroicons/react/24/outline'
import type { ProjectWithCounts } from '../../../../Model/Project/ProjectWithCounts.js'
import { Link } from 'react-router-dom'
import { AmpliconWidget } from '../../OrderManagementPage/AmpliconWidget.tsx'
import { DASHBOARD_WIDGET_CLASS } from './dashboardUtils.ts'

export const RecentProjectsWidget = ({ recentProjects }: { recentProjects: ProjectWithCounts[] | 'LOADING' }) => (
  <section className={`${DASHBOARD_WIDGET_CLASS} xl:col-span-12`}>
    <div className="mb-4 flex items-center justify-between gap-3">
      <div className="flex items-center gap-2">
        <FolderIcon className="h-5 w-5 text-slate-600" />
        <h2 className="text-lg font-semibold text-slate-900">Recent projects</h2>
      </div>
      <Link to="/projects" className="text-sm font-medium text-slate-700 hover:text-slate-900">
        View all
      </Link>
    </div>
    <div className="grid grid-cols-1 gap-3 lg:grid-cols-2">
      {recentProjects === 'LOADING' ? (
        <div className="rounded-lg border border-dashed border-slate-300 p-6 text-sm text-slate-500">Loading projects...</div>
      ) : recentProjects.length > 0 ? (
        recentProjects.map((project) => (
          <Link
            key={project.project.id}
            to={`/projects/${project.project.id}`}
            className="rounded-lg border border-slate-200 bg-slate-50 p-4 transition-colors hover:bg-slate-100"
          >
            <div className="flex items-start justify-between gap-4">
              <div className="min-w-0">
                <div className="truncate font-medium text-slate-900">{project.project.name}</div>
                <div className="mt-1 max-h-10 overflow-hidden text-sm text-slate-500">{project.project.description || 'No description'}</div>
              </div>
              {project.project.targetTaxonomy ? (
                <div className="shrink-0">
                  <AmpliconWidget amplicon={project.project.targetTaxonomy} showLabel={false} classNames="text-lg" />
                </div>
              ) : null}
            </div>
            <div className="mt-4 flex flex-wrap items-center gap-3 text-sm text-slate-600">
              <span>{project.sampleCount} samples</span>
              <span>{project.participantCount} participants</span>
            </div>
          </Link>
        ))
      ) : (
        <div className="rounded-lg border border-dashed border-slate-300 p-6 text-sm text-slate-500">No projects yet.</div>
      )}
    </div>
  </section>
)
